const ALL_ACTIONS = [
  'TrelloAddAttachmentToCardAction',
  'TrelloAddChecklistToCardAction',
  'TrelloAddMemberToCardAction',
  'TrelloCommentCardAction',
  'TrelloCopyCardAction',
  'TrelloCopyCommentCardAction',
  'TrelloCopyInboxCardAction',
  'TrelloCreateCardAction',
  'TrelloCreateCardFromCheckItemAction',
  'TrelloCreateCardFromEmailAction',
  'TrelloCreateInboxCardAction',
  'TrelloDeleteAttachmentFromCardAction',
  'TrelloMoveCardAction',
  'TrelloMoveCardToBoardAction',
  'TrelloMoveInboxCardToBoardAction',
  'TrelloRemoveChecklistFromCardAction',
  'TrelloRemoveMemberFromCardAction',
  'TrelloUpdateCardClosedAction',
  'TrelloUpdateCardCompleteAction',
  'TrelloUpdateCardDueAction',
  'TrelloUpdateCheckItemStateOnCardAction',
  'TrelloUpdateCustomFieldItemAction',
];

/**
 * This defines the supertype/subtype mappings in the schema.
 * For example, TrelloCardActions is a union that can be
 * any of the types listed below.
 *
 * https://www.apollographql.com/docs/react/data/fragments#defining-possibletypes-manually
 */
export const possibleTypes = {
  TrelloCardActions: ALL_ACTIONS,
  TrelloAction: ALL_ACTIONS,
};
